import { render } from "./PublicTemplate.vue?vue&type=template&id=193b56fe"
import script from "./PublicTemplate.vue?vue&type=script&lang=js"
export * from "./PublicTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__